import { render } from "./salary-components.vue?vue&type=template&id=39f0d578&scoped=true"
import script from "./salary-components.vue?vue&type=script&lang=js"
export * from "./salary-components.vue?vue&type=script&lang=js"

import "./salary-components.vue?vue&type=style&index=0&id=39f0d578&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f0d578"]])

export default __exports__